import Request from 'redux/config/services/Request'
import axios from 'axios'

type AttachmentType = 'image' | 'pdf'

export const getPresignedUrl = async (
  fileName: string,
  attachmentType: AttachmentType
) => {
  const response = await Request.post(
    '/ai_concierge/chat-attachments/upload/',
    {
      attachmentType,
      fileName,
    }
  )
  return response
}

export const uploadFileToS3 = async (url: string, file: File) => {
  const response = await axios.put(url, file, {
    headers: {
      'Content-Type': 'application/octet-stream',
    },
    withCredentials: false,
    maxBodyLength: Infinity,
    maxContentLength: Infinity,
    transformRequest: [(data) => data],
  })
  return response
}

export const getDownloadUrl = async (
  fileName: string,
  attachmentType: AttachmentType
) => {
  const response = await Request.post(
    '/ai_concierge/chat-attachments/download/',
    {
      attachmentType,
      fileName,
    }
  )
  return response
}

export const processReceipt = async (
  downloadUrl: string,
  contentType: string
) => {
  const response = await Request.post('/hr/tax_benefits/process_receipt/', {
    downloadUrl,
    contentType,
  })
  return response
}

export const confirmReceiptDetails = async (
  downloadUrl: string,
  receipts: {
    receiptId: string
    merchant: string
    amount: number
    receiptDate: string
    expenseType: string | null
    merchantCategory: string | null
    merchantCurrency: string
    merchantAmount: number
    employeeNote?: string | null
    manualReview: boolean
  }[]
) => {
  const payload = {
    download_url: downloadUrl,
    receipts: receipts.map((r) => ({
      receipt_id: r.receiptId,
      merchant: r.merchant,
      amount: r.amount,
      receipt_date: r.receiptDate,
      expense_type: r.expenseType,
      merchant_category: r.merchantCategory,
      merchant_currency: r.merchantCurrency,
      merchant_amount: r.merchantAmount,
      employee_note: r.employeeNote,
      manual_review: r.manualReview,
    })),
  }
  return Request.post(
    '/mobile/reimbursements/receipt_details/confirm/',
    payload
  )
}
